module.exports = __webpack_public_path__ + "static/media/bellabyte-brinde-caneta-personalizado.c02451d3.jpg";